import { ReactChild } from 'react';
import { Plan } from '../Dashboard.types';
import { PaymentPlanCard } from '../paymentPlanCard/PaymentPlanCard';

import styles from './SelectedView.module.css';

const SelectedView = ({
    children,
    plan
}: {
    children: ReactChild | null;
    plan: Plan;
}) => {
    return (
        <section className={styles.container}>
            {plan && (
                <div className={styles.paymentPlanCardContainer}>
                    <PaymentPlanCard
                        created={plan.payLink.created}
                        funded_at={plan.payLink.funded_at}
                        reference={plan.payLink.reference}
                        sellerName={plan.payLink.seller_trading_name}
                        amount={plan.payLink.amount}
                        status={plan.status}
                    />
                </div>
            )}
            {children}
        </section>
    );
};

// eslint-disable-next-line import/no-default-export
export default SelectedView;
